import classnames from 'classnames';
import React from 'react';

import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

import css from './defaultIconStyles.css';

export default function IconMcs({
    width = 14,
    height = 16,
    className,
    size,
}: IconProps) {
    return (
        <svg
            width={size || width}
            height={size || height}
            viewBox="0 0 20 20"
            className={classnames(css.main, className)}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.72833 4.14765C2.66268 4.76737 2 5.95139 2 7.23782V12.6327C2 13.8943 2.63686 15.0593 3.67062 15.6886L8.33723 18.5301C9.36643 19.1567 10.6336 19.1567 11.6628 18.5301L16.3294 15.6886C17.3626 15.0593 18 13.8943 18 12.6327V7.23782C18 5.95139 17.3378 4.76737 16.2717 4.14765L11.6051 1.43595C10.6057 0.854764 9.39478 0.854764 8.39494 1.43595L3.72833 4.14765ZM16.0003 12.6327V7.87444L11.6992 10.1132C11.2709 10.3359 11.0006 10.7925 11.0006 11.2914V16.492L15.3321 13.8547C15.7452 13.6035 16.0003 13.1374 16.0003 12.6327ZM9.00041 16.4925L4.66894 13.8553C4.25534 13.6035 4.0007 13.1374 4.0007 12.6327V7.70816L8.32912 10.0994C8.74222 10.328 9.00092 10.7756 9.00092 11.2634V16.4925H9.00041ZM10.6422 3.28932L15.1928 5.93397L11.0958 8.20067C10.3977 8.58654 9.56285 8.57493 8.87537 8.16794L4.95396 5.84846L9.35782 3.28879C9.75827 3.05706 10.2422 3.05706 10.6422 3.28932Z"
                className={classnames(css.colored)}
            />
        </svg>
    );
}
